// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tiptap p.is-editor-empty:first-child::before {
    color: #adb5bd;
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
  }
  
  .tiptap h1 {
    font-size: 2.5em;
    line-height: 1.2;
  }
  
  .tiptap h2 {
    font-size: 2em;
    line-height: 1.3;
  }
  
  .tiptap h3 {
    font-size: 1.75em;
    line-height: 1.4;
  }
  
  .tiptap h4 {
    font-size: 1.5em;
    line-height: 1.5;
  }
  
  .tiptap h5 {
    font-size: 1.25em;
    line-height: 1.6;
  }
  
  .tiptap h6 {
    font-size: 1em;
    line-height: 1.7;
    color: #666;
  }
  .tiptap {
    line-height: 1.5rem;
    > * + * {
      margin-top: 0.75em;
    }
  
    ol {
      list-style: decimal; /* Use decimal numbering */
      padding-left: 1.5em; /* Add left padding */
      display: inline-block;
    }
  
    ul {
      list-style: disc; /* Use decimal numbering */
      padding-left: 1.5em; /* Add left padding */
      display: inline-block;
    }
    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }
  
    pre {
      background: #0d0d0d;
      color: #fff;
      font-family: "JetBrainsMono", monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
  
      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 0.8rem;
      }
    }
  
    img {
      max-width: 100%;
      height: auto;
      cursor: pointer;
    }
  
    blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0d0d0d, 0.1);
    }
  
    hr {
      border: none;
      border-top: 2px solid rgba(#0d0d0d, 0.1);
      margin: 2rem 0;
    }
    .mention {
      background-color: #f4f4f5;
      border-radius: 0.4rem;
      -webkit-box-decoration-break: clone;
              box-decoration-break: clone;
      color: purple;
      padding: 0.1rem 0.3rem;
    }
    ul[data-type="taskList"] {
      list-style: none;
      margin-left: 0;
      padding: 0;
  
      li {
        align-items: center;
        display: flex;
        > label {
          align-items: center;
          display: flex;
          flex: 0 0 auto;
          margin-right: 0.5rem;
          -webkit-user-select: none;
                  user-select: none;
        }
  
        > div {
          flex: 1 1 auto;
        }
      }
  
      input[type="checkbox"] {
        cursor: pointer;
      }
  
      ul[data-type="taskList"] {
        margin: 0;
      }
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/MarkdownEditor/tiptapstyles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,+BAA+B;IAC/B,WAAW;IACX,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB;MACE,kBAAkB;IACpB;;IAEA;MACE,mBAAmB,EAAE,0BAA0B;MAC/C,mBAAmB,EAAE,qBAAqB;MAC1C,qBAAqB;IACvB;;IAEA;MACE,gBAAgB,EAAE,0BAA0B;MAC5C,mBAAmB,EAAE,qBAAqB;MAC1C,qBAAqB;IACvB;IACA;MACE,oCAAoC;MACpC,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,WAAW;MACX,uCAAuC;MACvC,qBAAqB;MACrB,qBAAqB;;MAErB;QACE,cAAc;QACd,UAAU;QACV,gBAAgB;QAChB,iBAAiB;MACnB;IACF;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,yCAAyC;IAC3C;;IAEA;MACE,YAAY;MACZ,wCAAwC;MACxC,cAAc;IAChB;IACA;MACE,yBAAyB;MACzB,qBAAqB;MACrB,mCAA2B;cAA3B,2BAA2B;MAC3B,aAAa;MACb,sBAAsB;IACxB;IACA;MACE,gBAAgB;MAChB,cAAc;MACd,UAAU;;MAEV;QACE,mBAAmB;QACnB,aAAa;QACb;UACE,mBAAmB;UACnB,aAAa;UACb,cAAc;UACd,oBAAoB;UACpB,yBAAiB;kBAAjB,iBAAiB;QACnB;;QAEA;UACE,cAAc;QAChB;MACF;;MAEA;QACE,eAAe;MACjB;;MAEA;QACE,SAAS;MACX;IACF;EACF","sourcesContent":[".tiptap p.is-editor-empty:first-child::before {\n    color: #adb5bd;\n    content: attr(data-placeholder);\n    float: left;\n    height: 0;\n    pointer-events: none;\n  }\n  \n  .tiptap h1 {\n    font-size: 2.5em;\n    line-height: 1.2;\n  }\n  \n  .tiptap h2 {\n    font-size: 2em;\n    line-height: 1.3;\n  }\n  \n  .tiptap h3 {\n    font-size: 1.75em;\n    line-height: 1.4;\n  }\n  \n  .tiptap h4 {\n    font-size: 1.5em;\n    line-height: 1.5;\n  }\n  \n  .tiptap h5 {\n    font-size: 1.25em;\n    line-height: 1.6;\n  }\n  \n  .tiptap h6 {\n    font-size: 1em;\n    line-height: 1.7;\n    color: #666;\n  }\n  .tiptap {\n    line-height: 1.5rem;\n    > * + * {\n      margin-top: 0.75em;\n    }\n  \n    ol {\n      list-style: decimal; /* Use decimal numbering */\n      padding-left: 1.5em; /* Add left padding */\n      display: inline-block;\n    }\n  \n    ul {\n      list-style: disc; /* Use decimal numbering */\n      padding-left: 1.5em; /* Add left padding */\n      display: inline-block;\n    }\n    code {\n      background-color: rgba(#616161, 0.1);\n      color: #616161;\n    }\n  \n    pre {\n      background: #0d0d0d;\n      color: #fff;\n      font-family: \"JetBrainsMono\", monospace;\n      padding: 0.75rem 1rem;\n      border-radius: 0.5rem;\n  \n      code {\n        color: inherit;\n        padding: 0;\n        background: none;\n        font-size: 0.8rem;\n      }\n    }\n  \n    img {\n      max-width: 100%;\n      height: auto;\n      cursor: pointer;\n    }\n  \n    blockquote {\n      padding-left: 1rem;\n      border-left: 2px solid rgba(#0d0d0d, 0.1);\n    }\n  \n    hr {\n      border: none;\n      border-top: 2px solid rgba(#0d0d0d, 0.1);\n      margin: 2rem 0;\n    }\n    .mention {\n      background-color: #f4f4f5;\n      border-radius: 0.4rem;\n      box-decoration-break: clone;\n      color: purple;\n      padding: 0.1rem 0.3rem;\n    }\n    ul[data-type=\"taskList\"] {\n      list-style: none;\n      margin-left: 0;\n      padding: 0;\n  \n      li {\n        align-items: center;\n        display: flex;\n        > label {\n          align-items: center;\n          display: flex;\n          flex: 0 0 auto;\n          margin-right: 0.5rem;\n          user-select: none;\n        }\n  \n        > div {\n          flex: 1 1 auto;\n        }\n      }\n  \n      input[type=\"checkbox\"] {\n        cursor: pointer;\n      }\n  \n      ul[data-type=\"taskList\"] {\n        margin: 0;\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
